import client from '../api/apiClient'
import { tokenConfig } from './'

export function reqGetProfileRoles (token) {
  return client().get(`/role`, tokenConfig(token))
}
